var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 1.49951C13.1495 1.49951 16.502 4.86026 16.502 8.99951C16.502 13.1403 13.1495 16.4995 9.00195 16.4995C4.86195 16.4995 1.50195 13.1403 1.50195 8.99951C1.50195 4.86026 4.86195 1.49951 9.00195 1.49951ZM9.00195 11.1978C8.64195 11.1978 8.34945 11.4903 8.34945 11.8503C8.34945 12.2103 8.64195 12.5103 9.00945 12.5103C9.36945 12.5103 9.66195 12.2103 9.66195 11.8503C9.66195 11.4903 9.36945 11.1978 9.00195 11.1978ZM9.00195 5.49701C8.64195 5.49701 8.34195 5.79776 8.34195 6.15701V9.47201C8.34195 9.83276 8.64195 10.1245 9.00195 10.1245C9.36195 10.1245 9.65445 9.83276 9.65445 9.47201V6.15701C9.65445 5.79776 9.36195 5.49701 9.00195 5.49701Z",
    fill: "#959595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle1);
export default __webpack_public_path__ + "static/media/Info Circle 1.db038261.svg";
export { ForwardRef as ReactComponent };